import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U2101, { U2101ROLES } from "./U2101";
import U2101LogicalUnitList from "./components/U2101LogicalUnitList";
import U2101LogicalUnitForm from "./components/U2101LogicalUnitForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2101Routes: RouteObject[] = [
  {
    path: "U2101",
    element: <U2000RequireRole allowedRoles={[U2101ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U2101 />,
        children: [
          { index: true, element: <U2101LogicalUnitList /> },
          { path: ":id", element: <U2101LogicalUnitForm /> },
        ],
      },
    ],
  },
];

export default U2101Routes;
